export const EmptyFunction = (): void => {
  // Nothing to do.
};
